import { render } from "./Mealplanning.vue?vue&type=template&id=1d3297dd&scoped=true"
import script from "./Mealplanning.vue?vue&type=script&lang=js"
export * from "./Mealplanning.vue?vue&type=script&lang=js"

import "./Mealplanning.vue?vue&type=style&index=0&id=1d3297dd&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1d3297dd"]])

export default __exports__